//This is for the local portal Test remember this one runs on http://localhost:3002 - "http://127.0.0.1:8000"
//This is what is needed for the Azure portal. - "https://driverwatch-api.azurewebsites.net"

const config = {
  API_URL: "https://driverwatch-api.azurewebsites.net"
};

export default config;